import moment from "moment";
import CheckNewOrders from "../symbols/checkNewOrdersFailed";

const initialState = {
  data: false,
  loading: false,
  error: false,
  timeStamp: moment().utc().format(),
};

export default function CheckNewOrdersFailedReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case CheckNewOrders.CHECK_NEW_ORDERS_FAILED:
      return { ...state, loading: true, error: false };
    case CheckNewOrders.CHECK_NEW_ORDERS_FAILED_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
        timeStamp: moment().utc().format(),
      };
    case CheckNewOrders.CHECK_NEW_ORDERS_FAILED_FAILURE:
      return {
        ...state,
        data: false,
        loading: false,
        error: true,
      };
    case CheckNewOrders.CLEAR_CHECK_NEW_ORDERS_FAILED:
      return {
        ...state,
        data: false,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
